import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Bookkonkandarshantourpackage() {



  const cardData =
  {
    keyword: 'Book Konkan Darshan Tour Packages from Pune by Bus ',
    heading: 'Sanavi Travels: Book Konkan Darshan Tour Packages from Pune by Bus',
    headingDescription: 'Sanavi Travels offers reliable Konkan Darshan Tour Packages from Pune by Bus, providing safe, comfortable, and well-organized travel solutions for families, senior citizens, pilgrimage groups, corporate tours, and leisure travelers planning a scenic Konkan journey from Pune. Our fleet of luxury AC and Non-AC buses ranging from 32, 35, 40, 45, to 50 seaters, along with tempo travellers on request, is well-maintained and equipped with push-back seating, ample legroom, and spacious luggage capacity to ensure a relaxed coastal travel experience. With experienced coastal-route drivers, customizable multi-day tour packages, transparent pricing, and dedicated trip coordination, Sanavi Travels ensures smooth, punctual, and enjoyable travel throughout the Konkan region. We offer convenient doorstep pickup across Pune including Hinjewadi, Wakad, Baner, Kothrud, Hadapsar, Pimpri-Chinchwad, Swargate, and Pune Railway Station, covering popular Konkan destinations such as Ganpatipule, Ratnagiri, Tarkarli, Malvan, Devgad, Kunkeshwar, Murud, Harihareshwar, Dapoli, and Alibaug. Choose Sanavi Travels to book Konkan Darshan tour packages from Pune by bus, ensuring comfort, safety, and a memorable coastal travel experience.',

    top: 'Top Places to Visit in Konkan with Sanavi Travels',


"topPlaces": [
  {
    "title": "Ganpatipule",
    "description": "Ganpatipule is a serene coastal town in the Konkan region, famous for its pristine beach and the 400-year-old Swayambhu Ganpati Temple. The white sandy beach, clear waters, and lush green surroundings create a peaceful environment. The temple attracts devotees from across Maharashtra, blending spirituality with natural beauty. Ganpatipule is a perfect destination for devotion, relaxation, and scenic coastal charm."
  },
  {
    "title": "Ratnagiri",
    "description": "Ratnagiri is a historic coastal city known for its scenic beaches, Alphonso mangoes, and cultural heritage. Attractions include Ratnadurg Fort, Thibaw Palace, and Bhatye Beach. The city is also the birthplace of freedom fighter Lokmanya Tilak. Ratnagiri beautifully combines history, nature, and authentic Konkani culture."
  },
  {
    "title": "Tarkarli Beach",
    "description": "Tarkarli Beach is one of the cleanest and most beautiful beaches in the Konkan region, famous for its white sand and crystal-clear waters. It is a popular destination for snorkeling, scuba diving, and water sports. The nearby Karli River adds to the scenic charm. Tarkarli is ideal for adventure seekers and nature lovers."
  },
  {
    "title": "Sindhudurg Fort",
    "description": "Sindhudurg Fort is a magnificent sea fort built by Chhatrapati Shivaji Maharaj in the 17th century. Located near Malvan, the fort showcases exceptional maritime engineering. It houses temples and offers stunning sea views. Sindhudurg Fort stands as a proud symbol of Maratha naval power and Konkan’s rich history."
  },
  {
    "title": "Alibaug",
    "description": "Alibaug is a popular beach destination in Konkan, known for its clean beaches and relaxed atmosphere. Key attractions include Alibaug Beach, Nagaon Beach, and Kolaba Fort. The town is ideal for water sports, coastal cuisine, and weekend getaways. Alibaug blends leisure, history, and natural beauty."
  },
  {
    "title": "Dapoli",
    "description": "Dapoli is a calm hill station by the sea, often referred to as the ‘Mini Mahabaleshwar of Konkan’. It is known for its pleasant climate, unspoiled beaches like Murud and Karde, and lush greenery. The town offers peaceful surroundings and scenic views. Dapoli is perfect for travelers seeking relaxation and nature."
  },
  {
    "title": "Murud-Janjira Fort",
    "description": "Murud-Janjira Fort is an unconquered sea fort located off the coast of Murud. Built by the Siddis, the fort stands strong amidst the Arabian Sea. Accessible only by boat, it features massive walls and bastions. Murud-Janjira reflects Konkan’s powerful maritime and military legacy."
  },
  {
    "title": "Malvan",
    "description": "Malvan is a coastal town famous for its beautiful beaches, Sindhudurg Fort, and authentic Malvani cuisine. Coconut trees, coral beaches, and traditional fishing villages define its charm. The town is also popular for snorkeling and scuba diving. Malvan offers a true experience of Konkan’s coastal culture."
  },
  {
    "title": "Guhagar Beach",
    "description": "Guhagar Beach is a clean and peaceful beach surrounded by lush greenery and coconut groves. Its long stretch of soft sand and calm waters make it ideal for relaxing walks. The nearby Vyadeshwar Temple adds spiritual significance. Guhagar is a hidden gem for those seeking serenity and natural beauty."
  },
  {
    "title": "Harihareshwar",
    "description": "Harihareshwar is a sacred coastal town known as the ‘Dakshin Kashi’ of Maharashtra. It is famous for the Harihareshwar Temple dedicated to Lord Shiva and its scenic beach. Surrounded by hills and sea, the town offers a tranquil spiritual atmosphere. Harihareshwar perfectly blends devotion, nature, and peace."
  }
]
,





"services": [
  {
    "name": "Book Konkan Darshan Tour Packages from Pune by Bus",
    "description": "Book Konkan Darshan Tour Packages from Pune by Bus offers well-planned and comfortable bus tours covering major Konkan destinations. Ideal for families, groups, and tourists, these packages include spacious buses, professional drivers, and smooth travel along scenic coastal routes. The service focuses on safety, comfort, and timely sightseeing, making Konkan darshan enjoyable and stress-free."
  },
  {
    "name": "Konkan Darshan Bus Tour Pune",
    "description": "Konkan Darshan Bus Tour Pune provides organized bus tours from Pune to popular Konkan destinations. Designed for group and family travel, the service offers comfortable seating, experienced chauffeurs, and reliable schedules. Passengers enjoy scenic coastal views while traveling in well-maintained buses for a memorable Konkan journey."
  },
  {
    "name": "AC Bus Konkan Darshan",
    "description": "AC Bus Konkan Darshan offers air-conditioned buses for a relaxed and comfortable coastal tour. Ideal for long-distance travel, these buses provide a cool environment, spacious seating, and smooth rides. Perfect for families and groups looking for comfort while exploring Konkan destinations."
  },
  {
    "name": "Luxury Bus Konkan Tour",
    "description": "Luxury Bus Konkan Tour provides premium buses with comfortable interiors and modern amenities for an enhanced travel experience. Suitable for luxury holidays, corporate groups, or special tours, this service combines elegance, safety, and convenience for Konkan travel."
  },
  {
    "name": "Family Konkan Bus Tour",
    "description": "Family Konkan Bus Tour is designed for families traveling together to Konkan. With spacious seating, safe driving practices, and comfortable buses, this service ensures an enjoyable journey for children, adults, and senior citizens throughout the tour."
  },
  {
    "name": "Group Travel Konkan Bus",
    "description": "Group Travel Konkan Bus caters to large groups planning Konkan darshan tours. Ideal for friends, tour operators, and organizations, the service offers reliable buses, coordinated travel, and professional drivers for smooth and well-managed group journeys."
  },
  {
    "name": "Affordable Konkan Bus Package",
    "description": "Affordable Konkan Bus Package provides budget-friendly tour options without compromising on comfort or safety. Suitable for cost-conscious travelers, these packages include well-maintained buses, experienced drivers, and transparent pricing for Konkan tours."
  },
  {
    "name": "Chauffeur Driven Konkan Bus",
    "description": "Chauffeur Driven Konkan Bus offers professional and experienced drivers for hassle-free coastal travel. Passengers can relax and enjoy scenic routes while chauffeurs handle driving, routes, and safety throughout the Konkan tour."
  },
  {
    "name": "Best Konkan Darshan Bus Pune",
    "description": "Best Konkan Darshan Bus Pune offers high-quality buses and dependable service for Konkan tours from Pune. Known for punctuality, comfort, and safety, this service is ideal for families, tourists, and group travelers seeking a premium Konkan travel experience."
  },
  {
    "name": "Pune Konkan Travel Bus",
    "description": "Pune Konkan Travel Bus provides reliable bus transport between Pune and Konkan destinations. With spacious interiors, luggage-friendly design, and skilled drivers, this service ensures a smooth and stress-free coastal journey."
  },
  {
    "name": "Tourist Bus Hire Konkan",
    "description": "Tourist Bus Hire Konkan offers buses for sightseeing and tourism across the Konkan region. Ideal for visiting beaches, temples, and coastal attractions, this service ensures organized travel with comfort and reliability."
  },
  {
    "name": "Coastal Tour Bus Pune",
    "description": "Coastal Tour Bus Pune specializes in scenic coastal journeys from Pune to Konkan. Comfortable buses, professional drivers, and planned routes make this service perfect for travelers wanting to explore Konkan’s natural beauty."
  },
  {
    "name": "Holiday Bus Package Konkan",
    "description": "Holiday Bus Package Konkan offers well-organized holiday tours for leisure travelers. Designed for families, friends, and groups, this service focuses on comfort, sightseeing convenience, and enjoyable coastal travel experiences."
  },
  {
    "name": "Konkan Trip Bus Service",
    "description": "Konkan Trip Bus Service provides dependable bus transport for complete Konkan tours. Suitable for short or extended trips, the service ensures comfort, safety, and professional support throughout the journey."
  },
  {
    "name": "Pune to Ratnagiri Bus Tour",
    "description": "Pune to Ratnagiri Bus Tour offers comfortable bus travel from Pune to Ratnagiri as part of Konkan darshan tours. Ideal for tourists and families, this service provides smooth coastal travel, experienced drivers, and a relaxed sightseeing experience."
  }
],
"tableData": [
  ["Book Konkan Darshan Tour Packages from Pune by Bus", "Konkan Darshan Bus Tour Pune"],
  ["AC Bus Konkan Darshan", "Luxury Bus Konkan Tour"],
  ["Family Konkan Bus Tour", "Group Travel Konkan Bus"],
  ["Affordable Konkan Bus Package", "Chauffeur Driven Konkan Bus"],
  ["Best Konkan Darshan Bus Pune", "Pune Konkan Travel Bus"],
  ["Tourist Bus Hire Konkan", "Coastal Tour Bus Pune"],
  ["Holiday Bus Package Konkan", "Konkan Trip Bus Service"],
  ["Pune to Ratnagiri Bus Tour", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Book Konkan Darshan Tour Packages from Pune by Bus with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers well-planned and comfortable Konkan Darshan tour packages from Pune by bus, ideal for family tours, group travel, and spiritual sightseeing."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Buses",
    "WhyChoosedescription": "Travel in air-conditioned, clean, and well-maintained buses designed for long-distance journeys across Konkan destinations."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Konkan Routes",
    "WhyChoosedescription": "Our professional drivers are experienced with Konkan coastal routes, ghats, and highways, ensuring safe and smooth travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides upfront pricing for Konkan Darshan bus tour packages, including fuel, tolls, and driver allowances."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings, itinerary planning, and travel queries."
  },
  {
    "WhyChooseheading": "Flexible Tour Packages",
    "WhyChoosedescription": "Choose from short trips, multi-day tours, or fully customized Konkan Darshan packages as per your group’s requirements."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All buses are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We ensure punctual departures and dependable service, making Sanavi Travels a trusted choice for Konkan Darshan tours from Pune."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels offer Konkan Darshan tour packages from Pune by bus?',
    answer: 'Yes, Sanavi Travels provides comfortable and well-organized Konkan Darshan tour packages from Pune by bus.'
  },
  {
    question: 'How can I book a Konkan Darshan tour package with Sanavi Travels?',
    answer: 'You can book easily through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What type of buses are used for the Konkan Darshan tour?',
    answer: 'We provide air-conditioned and well-maintained buses suitable for long-distance and coastal travel.'
  },
  {
    question: 'Are drivers included in the Konkan Darshan bus package?',
    answer: 'Yes, all tour packages include experienced and professional drivers familiar with Konkan routes.'
  },
  {
    question: 'Is the service available 24x7?',
    answer: 'Yes, our service is available round the clock for bookings and travel assistance.'
  },
  {
    question: 'Are the buses sanitized before the tour?',
    answer: 'Yes, all buses are thoroughly cleaned and sanitized before every journey.'
  },
  {
    question: 'Can I customize the Konkan Darshan tour package?',
    answer: 'Absolutely. Sanavi Travels offers customized Konkan Darshan packages according to your travel needs.'
  },
  {
    question: 'What payment options are available for the tour package?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is customer support available during the tour?',
    answer: 'Yes, our 24x7 customer support team is available throughout your Konkan Darshan journey.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Prakash Jadhav',
    feedback: 'Booked Konkan Darshan tour package from Pune with Sanavi Travels. Very comfortable bus, experienced driver, and well-planned itinerary.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Sneha Sawant',
    feedback: 'Amazing experience! Clean bus, smooth journey, and great coordination. Sanavi Travels made our Konkan trip memorable.',
    rating: 5
  }
];









































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];











const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Book Konkan Darshan Tour Packages from Pune by Bus - Sanavi Travels",
  "description": "Konkan Darshan tour bus packages from Pune by Sanavi Travels for family trips, group travel, and holiday tours. Choose AC and luxury buses for safe, comfortable, and affordable travel along the Konkan coast, including Ratnagiri and surrounding destinations.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1700"
  }
};





  return (
    <div>
<Helmet>
  <title>
    Book Konkan Darshan Tour Packages from Pune by Bus Starting from ₹45 Per Km | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book Konkan Darshan tour packages from Pune with Sanavi Travels. AC and luxury buses for family trips, group travel, and holiday tours along the Konkan coast at affordable rates."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/32.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Bookkonkandarshantourpackage;